import { subscribeToBets } from './bets_subscriber';

export const subscribeToEventBets = (eventId, callbacks) => (
  subscribeToBets(({ eventIds, betUpdateType }) => {
    if (eventIds.includes(eventId)) {
      callbacks[betUpdateType]?.();
    }
  })
);
